import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/organisms/Homesections/Introsection/Navbar/Navbar';
import Homepage from './components/pages/Homepage/Homepage';
import Aboutpage from './components/pages/Aboutpage/Aboutpage';
import Characterspage from './components/pages/Characterspage/Characterspage';
// import Contactuspage from './components/pages/Contactuspage/Contactuspage';
import Fieldspage from './components/pages/Fieldspage/Fieldspage';
import Placespage from './components/pages/Placespage/Placespage';
import Notfound from './components/pages/Notfound';
import Char from './components/pages/Char/Char';
import Allnews from './components/pages/Allnews/Allnews';
import Newsdetails from './components/pages/Newsdetails/Newsdetails';
import ScrollToTop from './components/organisms/ScrollToTop';

function App() {
  return (
    <div className="App">
     {/* <Homepage/> */}

     <Router>
      <ScrollToTop />
      <Navbar/>
      <Routes>
        <Route path='/' element={<Homepage/>}/>
        <Route path='/about' element={<Aboutpage/>}/>
        <Route path='/characters' element={<Characterspage/>}/>
        {/* <Route path='/contact' element={<Contactuspage/>}/> */}
        <Route path='/fields' element={<Fieldspage/>}/>
        <Route path='/places' element={<Placespage/>}/>

        <Route path= 'about.aspx' element={<Char/>}/>
        <Route path= '/allnews' element={<Allnews/>}/>
        <Route path="/allnews/:id" element={<Newsdetails />} />

        <Route path="*" element={<Notfound/>} />

      </Routes>
     </Router>
    </div>
  );
}

export default App;
